document.addEventListener('DOMContentLoaded', () => {
	let galleryCTAs = document.querySelectorAll('.gallery-cta')
	let sliderInstances = []

	function init() {
		sliderInstances.forEach((instance) => instance.destroy())
		sliderInstances = []

		galleryCTAs.forEach((section) => {
			let sliders = section.querySelectorAll('.keen-slider')

			for (let i = 0; i < sliders.length; i++) {
				let speed = i == 0 ? 12000 : i == 1 ? 15000 : 20000
				let duration =
					sliders[i].querySelectorAll('.keen-slider__slide').length * speed
				let instance = createPortfolioSlider(
					sliders[i],
					{ duration: duration, easing: linear },
					i == 1 || i == 3 ? true : false
				)
				sliderInstances.push(instance)
			}
		})
	}

	init()

	let resizeTimeout
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout)
		resizeTimeout = setTimeout(init, 150)
	})

	function linear(x) {
		return x
	}

	function createPortfolioSlider(element, animationOptions, reverseDirection) {
		let maxIdx = null
		return new KeenSlider(element, {
			vertical: false,
			loop: true,
			renderMode: 'precision',
			mode: 'free',
			slides: { perView: 1.5 },
			breakpoints: {
				'(min-width: 512px)': {
					slides: { perView: 2 },
				},
				'(min-width: 768px)': {
					vertical: true,
					slides: { perView: 'auto' },
				},
			},
			created(s) {
				maxIdx = s.track.details.slides.length - 1
				if (reverseDirection) {
					maxIdx = -maxIdx
				}
				s.moveToIdx(maxIdx, true, animationOptions)
			},
			updated(s) {
				s.moveToIdx(s.track.details.abs + maxIdx, true, animationOptions)
			},
			animationEnded(s) {
				s.moveToIdx(s.track.details.abs + maxIdx, true, animationOptions)
			},
		})
	}
})
